import channelStatus from './channelStatus'
import comingSoonPosBanner from './comingSoonPosBanner'
import createEdit from './createEdit'
import detail from './detail'
import landing from './landing'
import oloConfig from './oloConfig'
import oloPlaceholder from './oloPlaceholder'
import overview from './overview'
import unsupportedPosBanner from './unsupportedPosBanner'

export default {
  landing,
  create_edit: createEdit,
  detail,
  overview,
  channel_status: channelStatus,
  olo_config: oloConfig,
  olo_placeholder: oloPlaceholder,
  unsupported_pos_banner: unsupportedPosBanner,
  coming_soon_pos_banner: comingSoonPosBanner,
}
